import { render } from "./HtmlComponent.vue?vue&type=template&id=1a2e38eb"
import script from "./HtmlComponent.vue?vue&type=script&lang=js"
export * from "./HtmlComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__